import * as dateFns from 'date-fns'
import { enUS, es } from 'date-fns/locale'
import { useMemo } from 'react'

export const useDateLocale = () =>
  useMemo(() => {
    const lang = navigator.language

    if (lang.startsWith('es')) {
      return es
    }

    if (lang.startsWith('en')) {
      return enUS
    }

    return enUS
  }, [])

/**
 * Exposes Date FNS methods with the default locale based on the user's language.
 */
export const useDateUtils = () => {
  const locale = useDateLocale()

  const formatDistanceToNow: typeof dateFns.formatDistanceToNow = (date, options) =>
    dateFns.formatDistanceToNow(date, {
      locale,
      ...options,
    })

  const formatDistance: typeof dateFns.formatDistance = (date, baseDate, options) =>
    dateFns.formatDistance(date, baseDate, {
      locale,
      ...options,
    })

  const format: typeof dateFns.format = (date, formatStr, options) =>
    dateFns.format(date, formatStr, {
      locale,
      ...options,
    })

  return {
    formatDistanceToNow,
    formatDistance,
    format,
  }
}
